(function () {
    const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

    function initInspirationHotspotsSection(section) {
        if (!section || section.dataset.inspirationHotspotsInitialized === 'true') return;

        section.dataset.inspirationHotspotsInitialized = 'true';

        const sliderElement = section.querySelector('[data-inspiration-hotspots-slider]');
        const mobileCardContainer = section.querySelector('[data-inspiration-hotspots-mobile-card]');
        const desktopHotspotTrigger = section.dataset.desktopHotspotTrigger || 'hover';
        let slider = null;

        if (sliderElement && typeof Splide !== 'undefined') {
            const slideCount = sliderElement.querySelectorAll('.splide__slide').length;

            slider = new Splide(sliderElement, {
                type: slideCount > 1 ? 'loop' : 'slide',
                clones: slideCount > 1 ? Math.max(slideCount, 3) : 0,
                perPage: 1,
                perMove: 1,
                gap: 0,
                arrows: false,
                pagination: false,
                drag: true,
                snap: true,
                focus: 'center',
                trimSpace: false,
                padding: {
                    left: '8px',
                    right: '8px'
                },
                breakpoints: {
                    750: {
                        padding: {
                            left: '10vw',
                            right: '10vw'
                        }
                    },
                    990: {
                        padding: {
                            left: '10vw',
                            right: '10vw'
                        }
                    },
                    1200: {
                        padding: {
                            left: '12vw',
                            right: '12vw'
                        }
                    }
                },
                mediaQuery: 'min'
            });

            slider.on('move', function () {
                clearActiveHotspots(section);
            });

            slider.on('mounted moved', function () {
                window.requestAnimationFrame(() => {
                    const hasHotspot = activateDefaultHotspot(section, mobileCardContainer);

                    if (!hasHotspot) {
                        clearMobileCard(mobileCardContainer);
                    }
                });
            });

            slider.mount();
            initDragCursor(section, sliderElement);

            window.requestAnimationFrame(() => {
                const hasHotspot = activateDefaultHotspot(section, mobileCardContainer);

                if (!hasHotspot) {
                    clearMobileCard(mobileCardContainer);
                }
            });
        }

        section.addEventListener('click', (event) => {
            const button = event.target.closest('.inspiration-hotspots__point-button');

            if (!button || !section.contains(button)) return;

            const hotspot = button.closest('[data-inspiration-hotspot]');

            if (!hotspot) return;

            event.preventDefault();
            event.stopPropagation();

            if (DESKTOP_QUERY.matches && desktopHotspotTrigger !== 'click') return;

            activateHotspot(section, hotspot, mobileCardContainer);
        });
        section.addEventListener('mouseover', (event) => {
            if (!DESKTOP_QUERY.matches) return;
            if (desktopHotspotTrigger !== 'hover') return;

            const button = event.target.closest('.inspiration-hotspots__point-button');

            if (!button || !section.contains(button)) return;

            const hotspot = button.closest('[data-inspiration-hotspot]');

            if (!hotspot || hotspot.classList.contains('is-active')) return;

            activateHotspot(section, hotspot, mobileCardContainer);
        });

        section.addEventListener('focusin', (event) => {
            if (!DESKTOP_QUERY.matches) return;

            const button = event.target.closest('.inspiration-hotspots__point-button');

            if (!button || !section.contains(button)) return;

            const hotspot = button.closest('[data-inspiration-hotspot]');

            if (!hotspot || hotspot.classList.contains('is-active')) return;

            activateHotspot(section, hotspot, mobileCardContainer);
        });

        section.addEventListener('mouseleave', () => {
            if (!DESKTOP_QUERY.matches) return;
            if (desktopHotspotTrigger === 'click') return;

            clearActiveHotspots(section);
        });

        document.addEventListener('click', (event) => {
            if (section.contains(event.target)) return;

            clearActiveHotspots(section);
        });

        window.addEventListener('resize', debounce(() => {
            const activeHotspot = section.querySelector('[data-inspiration-hotspot].is-active');

            if (!activeHotspot) return;

            if (DESKTOP_QUERY.matches) {
                clearMobileCard(mobileCardContainer);
                updateDesktopCardPlacement(activeHotspot);
            } else {
                renderMobileCard(activeHotspot, mobileCardContainer);
            }
        }, 150));
    }

    function activateDefaultHotspot(section, mobileCardContainer) {
        if (!section) return false;

        const hasActiveHotspot = section.querySelector('[data-inspiration-hotspot].is-active');

        if (hasActiveHotspot) return true;

        const activeSlide =
            section.querySelector('.splide__slide.is-active:not(.splide__slide--clone)') ||
            section.querySelector('.splide__slide.is-active');

        if (!activeSlide) return false;

        const defaultHotspot = activeSlide.querySelector('[data-inspiration-hotspot]');

        if (!defaultHotspot) return false;

        activateHotspot(section, defaultHotspot, mobileCardContainer);

        return true;
    }

    function activateHotspot(section, hotspot, mobileCardContainer) {
        const isAlreadyActive = hotspot.classList.contains('is-active');

        if (isAlreadyActive && !DESKTOP_QUERY.matches) {
            return;
        }

        clearActiveHotspots(section);

        hotspot.classList.add('is-active');

        const button = hotspot.querySelector('.inspiration-hotspots__point-button');

        if (button) {
            button.setAttribute('aria-expanded', 'true');
        }

        if (DESKTOP_QUERY.matches) {
            updateDesktopCardPlacement(hotspot);
            return;
        }

        renderMobileCard(hotspot, mobileCardContainer);
    }

    function clearActiveHotspots(section) {
        const activeHotspots = section.querySelectorAll('[data-inspiration-hotspot].is-active');

        activeHotspots.forEach((hotspot) => {
            hotspot.classList.remove('is-active', 'is-flipped-x', 'is-flipped-y');

            const button = hotspot.querySelector('.inspiration-hotspots__point-button');

            if (button) {
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }

    function updateDesktopCardPlacement(hotspot) {
        if (!DESKTOP_QUERY.matches) return;

        const media = hotspot.closest('.inspiration-hotspots__media');
        const marker = hotspot.querySelector('.inspiration-hotspots__point-marker');
        const card = hotspot.querySelector('[data-inspiration-hotspot-card]');

        if (!media || !marker || !card) return;

        hotspot.classList.remove('is-flipped-x', 'is-flipped-y');

        requestAnimationFrame(() => {
            const mediaRect = media.getBoundingClientRect();
            const markerRect = marker.getBoundingClientRect();
            const cardRect = card.getBoundingClientRect();
            const gap = 16;

            const markerCenterX = markerRect.left + markerRect.width / 2 - mediaRect.left;
            const markerCenterY = markerRect.top + markerRect.height / 2 - mediaRect.top;

            const overflowsRight = markerCenterX + cardRect.width + gap > mediaRect.width;
            const overflowsBottom = markerCenterY + cardRect.height / 2 > mediaRect.height;

            if (overflowsRight) {
                hotspot.classList.add('is-flipped-x');
            }

            if (overflowsBottom) {
                hotspot.classList.add('is-flipped-y');
            }
        });
    }

    function renderMobileCard(hotspot, mobileCardContainer) {
        if (!mobileCardContainer) return;

        const card = hotspot.querySelector('[data-inspiration-hotspot-card]');

        if (!card) {
            clearMobileCard(mobileCardContainer);
            return;
        }

        mobileCardContainer.innerHTML = '';
        mobileCardContainer.appendChild(card.cloneNode(true));
        mobileCardContainer.classList.add('is-visible');
    }

    function clearMobileCard(mobileCardContainer) {
        if (!mobileCardContainer) return;

        mobileCardContainer.innerHTML = '';
        mobileCardContainer.classList.remove('is-visible');
    }

    function initDragCursor(section, sliderElement) {
        if (!section || !sliderElement) return;

        const wrapper = section.querySelector('.inspiration-hotspots__slider-wrapper');

        if (!wrapper) return;

        let cursor = wrapper.querySelector('.inspiration-hotspots__drag-cursor');

        if (!cursor) {
            cursor = document.createElement('div');
            cursor.className = 'inspiration-hotspots__drag-cursor';
            cursor.innerHTML = '<span class="inspiration-hotspots__drag-cursor-label">Drag</span>';
            wrapper.appendChild(cursor);
        }

        const hideCustomCursor = () => {
            cursor.classList.remove('is-visible', 'is-dragging');
            sliderElement.classList.remove('is-custom-cursor-active');
        };

        const showCustomCursor = () => {
            cursor.classList.add('is-visible');
            sliderElement.classList.add('is-custom-cursor-active');
        };

        const moveCursor = (event) => {
            if (!DESKTOP_QUERY.matches) {
                hideCustomCursor();
                return;
            }

            const isInteractiveTarget = event.target.closest(
                [
                    'a',
                    'button',
                    'input',
                    'select',
                    'textarea',
                    '.inspiration-hotspots__point-button',
                    '.inspiration-hotspots__product-image-link',
                    '.inspiration-hotspots__product-title',
                    '.inspiration-hotspots__product-link'
                ].join(',')
            );

            if (isInteractiveTarget) {
                hideCustomCursor();
                return;
            }

            const activeMedia =
                sliderElement.querySelector('.splide__slide.is-active:not(.splide__slide--clone) .inspiration-hotspots__media') ||
                sliderElement.querySelector('.splide__slide.is-active .inspiration-hotspots__media');

            if (!activeMedia) {
                hideCustomCursor();
                return;
            }

            const activeMediaRect = activeMedia.getBoundingClientRect();
            const isInsideActiveMedia =
                event.clientX >= activeMediaRect.left &&
                event.clientX <= activeMediaRect.right &&
                event.clientY >= activeMediaRect.top &&
                event.clientY <= activeMediaRect.bottom;

            if (!isInsideActiveMedia) {
                hideCustomCursor();
                return;
            }

            const wrapperRect = wrapper.getBoundingClientRect();

            cursor.style.setProperty('--cursor-x', `${event.clientX - wrapperRect.left}px`);
            cursor.style.setProperty('--cursor-y', `${event.clientY - wrapperRect.top}px`);
            showCustomCursor();
        };

        sliderElement.addEventListener('mousemove', moveCursor);

        sliderElement.addEventListener('mouseenter', (event) => {
            moveCursor(event);
        });

        sliderElement.addEventListener('mouseleave', () => {
            hideCustomCursor();
        });

        sliderElement.addEventListener('mousedown', () => {
            if (!DESKTOP_QUERY.matches) return;

            cursor.classList.add('is-dragging');
        });

        window.addEventListener('mouseup', () => {
            cursor.classList.remove('is-dragging');
        });

        sliderElement.addEventListener('touchstart', () => {
            hideCustomCursor();
        });
    }

    function debounce(callback, delay) {
        let timeout = null;

        return function () {
            window.clearTimeout(timeout);

            timeout = window.setTimeout(callback, delay);
        };
    }

    function initAllInspirationHotspotsSections() {
        document
            .querySelectorAll('[data-inspiration-hotspots]')
            .forEach(initInspirationHotspotsSection);
    }

    document.addEventListener('DOMContentLoaded', initAllInspirationHotspotsSections);

    document.addEventListener('shopify:section:load', (event) => {
        initInspirationHotspotsSection(event.target.querySelector('[data-inspiration-hotspots]'));
    });
})();